// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mp-0";
export var animationContainer = "_mp-1";
export var itemPrice = "_mp-a";
export var itemizedContent = "_mp-9";
export var itemizedHeader = "_mp-7";
export var itemizedRow = "_mp-8";
export var itemizedSection = "_mp-6";
export var modalContent = "_mp-2";
export var orderName = "_mp-3";
export var refundOption = "_mp-4";
export var refundOptionsContainer = "_mp-5";
export var shippingLabel = "_mp-b";
export var totalRow = "_mp-c";